import * as swcHelpers from '@swc/helpers';
import { validateResponse } from '../response.js';
import { sendFileResponse } from './specs.js';

const sendFile = function() {
    var _ref = swcHelpers.asyncToGenerator(function*(apiUrl, { scope , referenceId , uploadedFile , uploadToken , alias  }, init) {
        const formData = new FormData();
        formData.append('scope', scope);
        formData.append('referenceId', referenceId);
        formData.append('uploadedFile', uploadedFile, alias || uploadedFile.name);
        return validateResponse(sendFileResponse, (yield fetch(`${apiUrl}/upload/file`, swcHelpers.objectSpread({
            method: 'POST',
            body: formData,
            headers: {
                'x-upload-token': uploadToken
            }
        }, init))));
    });
    return function sendFile(apiUrl, _, init) {
        return _ref.apply(this, arguments);
    };
}();

export { sendFile };
//# sourceMappingURL=send-file.js.map
